import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, ShieldAlert, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";
import { usePageMeta } from "../hooks/usePageMeta";

export default function UnsubscribePage() {
  usePageMeta("Unsubscribe | MacWay Estate Services", "Unsubscribe from MacWay estate sale emails.");
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState(token ? "loading" : "invalid");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) return;
    (async () => {
      try {
        const { data } = await api.post("/subscribers/unsubscribe", { token });
        setMessage(data.message);
        setState("done");
      } catch (err) {
        setMessage(formatApiErrorDetail(err.response?.data?.detail));
        setState("invalid");
      }
    })();
  }, [token]);

  return (
    <main className="min-h-[60vh] bg-sand flex items-center justify-center py-16 px-4" data-testid="unsubscribe-page">
      <div className="w-full max-w-md bg-white border border-linen p-8 md:p-10 text-center">
        {state === "loading" && (
          <>
            <Loader2 className="w-10 h-10 text-forest mx-auto animate-spin" />
            <h1 className="mt-5 text-3xl font-medium text-ink">Updating your preference…</h1>
          </>
        )}
        {state === "done" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-forest mx-auto" />
            <h1 className="mt-5 text-3xl font-medium text-ink" data-testid="unsubscribe-success">You're unsubscribed</h1>
            <p className="mt-3 text-sm text-ink/65 leading-relaxed">{message}</p>
          </>
        )}
        {state === "invalid" && (
          <>
            <ShieldAlert className="w-12 h-12 text-brass mx-auto" />
            <h1 className="mt-5 text-3xl font-medium text-ink" data-testid="unsubscribe-invalid">Link not valid</h1>
            <p className="mt-3 text-sm text-ink/65 leading-relaxed">{message || "This unsubscribe link is invalid or has already been used."}</p>
          </>
        )}
        <Link to="/" className="btn-primary mt-8 w-full" data-testid="unsubscribe-home-link">
          Back to MacWay Estate Services
        </Link>
      </div>
    </main>
  );
}
